import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import { reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { isRequestInprogress } from '../firmsSelectors';
import { createFirm } from '../firmsActions';
import ManageFirm from './ManageFirm';
import { validateCreate } from './ValidateCreateFirm';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '100vh',
  },
  innerContainer: {
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
  },
  button: {
    float: 'right',
  },
  updateButton: {
    float: 'right',
    marginTop: theme.spacing(3),
  },
  titleText: {
    ...theme.typography.h5,
  },
  loadingSpinner: {
    position: 'relative',
    left: '44%',
  },
}));

let CreateFirm = (props) => {
  const {
    history,
    reset,
    invalid,
    createNewFirm,
    isLoading,
  } = props;
  const classes = useStyles();

  const onCancel = () => {
    reset();
    history.replace('/firms');
  };

  return (
    <Grid
      container
      spacing={6}
      direction="column"
      alignItems="center"
      justify="center"
      className={classes.container}
    >
      <Grid
        container
        spacing={4}
        item
        xs={8}
      >
        <Grid item xs={12}>
          <IconButton
            className={classes.button}
            onClick={onCancel}
          >
            <Close />
          </IconButton>
          <Typography variant="h5" className={classes.titleText}>Create New Firm </Typography>
          {isLoading && <CircularProgress className={classes.loadingSpinner} />}
        </Grid>
        <ManageFirm {...props} />
        <Grid xs={12} item>
          <Button
            color="primary"
            variant="contained"
            className={classes.updateButton}
            disabled={invalid || isLoading}
            onClick={() => createNewFirm()}
          >
            CREATE
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

CreateFirm.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
  }).isRequired,
  reset: PropTypes.func.isRequired,
  createNewFirm: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const isLoading = isRequestInprogress(state);
  return { isLoading };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  createNewFirm: () => dispatch(createFirm(ownProps.history)),
});

CreateFirm = reduxForm({
  form: 'createFirm',
  validate: validateCreate,
  destroyOnUnmount: true,
  enableReinitialize: true,
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
})(CreateFirm);

export default connect(mapStateToProps, mapDispatchToProps)(CreateFirm);
